import { schema, schemaDefaultValues } from "./schema";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useContext, useState } from "react";
import { ContextContracting } from "../../context";
import reqCardToken from "../../../../services/reqAsaas/reqCardToken";
import Notification, { handleMessageError } from "../../../../components/toast";
import { handleOpenModal, handleCloseModal } from "../../../../util/libModal";
import { fi } from "date-fns/locale";
import { set } from "date-fns";
import { deleteSession } from "../../../../util/libLocalStorage";
import { toast } from "react-toastify";
import functions from "../../../../util/functions";

export const IndexHook = () => {
	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		setError,
		reset,
		watch,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "all",
		resolver: zodResolver(schema),
		defaultValues: schemaDefaultValues,
	});

	const { handlePriorStage, createBodyBilling } = useContext(ContextContracting);
	const [identModal, setIdentModal] = useState("modalCheckPayment");
	const [statusPaymentProcess, setStatusPaymentProcess] = useState("pending");
	const [payLoadSuccessData, setPayLoadSuccessData] = useState([]);
	const [errorPaymentProcess, setErrorPaymentProcess] = useState(null);

	const handleOnSubmit = async (data) => {
		setStatusPaymentProcess("pending");
		setErrorPaymentProcess(null);
		try {
			handleOpenModal(identModal);
			const remote_ip = await functions.getClientIP();
			const [expiryMonth, expiryYear] = data.expirationDate.split("/");

			const billing = createBodyBilling(data.idCustumer);

			const card = {
				...data,
				ambiente: 1,
				remote_ip,
				expiryMonth,
				expiryYear,
			};

			const body = { billing, card };

			const responseToken = await reqCardToken.createPayInvoiceCard(body);

			setPayLoadSuccessData(responseToken);

			setStatusPaymentProcess("success");
		} catch (error) {
			if (error?.message === "Nenhum plano selecionado para a empresa!") {
				handleCloseModalPayment(identModal);
				toast.error(error?.message);
				return;
			}

			handleMessageError(error);
			setErrorPaymentProcess(error.message);
			setStatusPaymentProcess("error");
			setPayLoadSuccessData([]);
		} finally {
		}
	};

	const handleCloseModalPayment = () => {
		if (statusPaymentProcess === "success") {
			handleCloseModal("StoreConfirmation");
			deleteSession("sessionStatus");
			document.location = "/";
		} else handleCloseModal(identModal);
	};

	return {
		//hooks
		handleOnSubmit,
		handlePriorStage,

		//useForm
		register,
		handleSubmit,

		control,

		//formState
		reset,
		errors,
		isSubmitting,

		//modal mensagem confirmação
		identModal,
		handleOpenModal,
		handleCloseModalPayment,

		statusPaymentProcess,
		errorPaymentProcess,
		payLoadSuccessData,
	};
};
